import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  query,
  orderBy,
  limit,
  startAfter,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { db } from "@/firebase/config";
import { Mail, Trash2 } from "lucide-react";

const PAGE_SIZE = 20;

const Contacts = () => {
  const [contacts, setContacts] = useState([]);
  const [lastDoc, setLastDoc] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [replyingTo, setReplyingTo] = useState(null);

  const fetchContacts = async (nextPage = false) => {
    setLoading(true);
    let q = query(
      collection(db, "contact_web"),
      orderBy("createdAt", "desc"),
      limit(PAGE_SIZE)
    );
    if (nextPage && lastDoc) {
      q = query(
        collection(db, "contact_web"),
        orderBy("createdAt", "desc"),
        startAfter(lastDoc),
        limit(PAGE_SIZE)
      );
    }
    const snapshot = await getDocs(q);
    const docs = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setContacts(nextPage ? (prev) => [...prev, ...docs] : docs);
    setLastDoc(snapshot.docs[snapshot.docs.length - 1]);
    setHasMore(snapshot.docs.length === PAGE_SIZE);
    setLoading(false);
  };

  const deleteContact = async (id) => {
    if (!window.confirm("Are you sure you want to delete this contact?")) return;
    try {
      await deleteDoc(doc(db, "contact_web", id));
      setContacts((prev) => prev.filter((c) => c.id !== id));
    } catch (error) {
      console.error("Error deleting contact:", error);
      alert("Failed to delete contact");
    }
  };

  useEffect(() => {
    fetchContacts();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-6 text-forest-green">
        Contact Submissions
      </h1>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white rounded-lg shadow border border-gray-200">
          <thead>
            <tr className="bg-gray-100">
              <th className="px-4 py-3 text-left font-semibold text-black border-b">
                Name
              </th>
              <th className="px-4 py-3 text-left font-semibold text-black border-b">
                Email
              </th>
              <th className="px-4 py-3 text-left font-semibold text-black border-b">
                Subject
              </th>
              <th className="px-4 py-3 text-left font-semibold text-black border-b">
                Message
              </th>
              <th className="px-4 py-3 text-left font-semibold text-black border-b">
                Date
              </th>
              <th className="px-4 py-3 text-left font-semibold text-black border-b">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {contacts.map((c) => (
              <tr key={c.id} className="border-b hover:bg-gray-50">
                <td className="px-4 py-3 text-black align-top">{c.fullName}</td>
                <td className="px-4 py-3 text-black align-top">{c.email}</td>
                <td className="px-4 py-3 text-black align-top">{c.subject}</td>
                <td
                  className="px-4 py-3 text-black align-top max-w-xs truncate"
                  title={c.message}
                >
                  {c.message}
                </td>
                <td className="px-4 py-3 text-black align-top">
                  {c.createdAt?.toDate?.().toLocaleString?.() || ""}
                </td>
                <td className="px-4 py-3 text-black align-top">
                  <button
                    onClick={() => deleteContact(c.id)}
                    className="text-red-500 hover:text-red-700 p-2 rounded hover:bg-red-50 transition-colors"
                    title="Delete"
                  >
                    <Trash2 size={18} />
                  </button>
                </td>
              </tr>
            ))}
            {contacts.length === 0 && (
              <tr>
                <td colSpan={6} className="px-4 py-8 text-center text-gray-500">
                  No contact submissions found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {hasMore && (
        <button
          className="mt-6 px-6 py-2 bg-forest-green text-white rounded shadow hover:bg-copper-brown"
          onClick={() => fetchContacts(true)}
          disabled={loading}
        >
          {loading ? "Loading..." : "Load More"}
        </button>
      )}
    </div>
  );
};

export default Contacts;
